/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'townsquare-comments.comment-action-bar.delete-button': '刪除',
  'townsquare-comments.comment-action-bar.edit-button': '編輯',
  'townsquare-comments.comment-action-bar.reply-button': '回覆',
  'townsquare-comments.comment.edited-date': '編輯日期：{time}',
  'townsquare-comments.comments.comments-title': '{itemCount, plural, =0 {留言} other {{itemCount,number} 則留言}}',
};
